export default class RedirectToEstimator {
    constructor($element) {
        this.$element = $element;
        this.init();
    }

    init() {
        this.baseUrl = this.$element.attr("href");

        $('body').on('click', 'a[data-mount="RedirectToEstimator"]', (event) => {

            event.preventDefault();
            this.RedirectToEstimator();
        });
    }

    RedirectToEstimator() {
        let currentUrl = encodeURIComponent(window.location.href);

        // Vérifier si l'URL contient déjà un "?"
        let redirectUrl = `${this.baseUrl}?source=${currentUrl}`;

        window.location.href = redirectUrl;
    }
}
